import { useProductSummaryImage } from '../hooks/useProductSummaryImage';

type ProductSummaryImageContainerProps = { children: React.ReactNode };

const ProductSummaryImageContainer = ({ children }: ProductSummaryImageContainerProps) => {
	const { blockClass, componentId } = useProductSummaryImage();

	return (
		<div
			data-selection={componentId}
			className={`imageContainer imageWrapper ${blockClass ? `imageWrapper--${blockClass} vtex-product-summary-2-x-imageWrapper--${blockClass}` : ''} vtex-product-summary-2-x-imageContainer vtex-product-summary-2-x-imageWrapper db w-100 center`}
		>
			{children}
		</div>
	);
};

export default ProductSummaryImageContainer;
